import '@arco-design/web-react/es/_util/react-19-adapter.js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import '@arco-design/web-react/dist/css/arco.css';
import 'jukun-ui-standard/ui-standard.css';
import './styles/portal.css';
import { App } from './app/App';
import { PortalOverlayProvider } from './components/PortalOverlayProvider';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PortalOverlayProvider>
      <App />
    </PortalOverlayProvider>
  </React.StrictMode>,
);
